import { colors } from '@guryou/colors';
import { typographyOverrides } from '@guryou/html-theme';
import styled from 'styled-components';
import { LinkButton } from '../buttons';
import propsToCss from '../utils/propsToCss';
const DefaultText = styled.p`
  ${props => propsToCss({
  ...typographyOverrides.MuiTypography.body1,
  ...props
})}
`;
const MediumText = styled.p`
  ${props => propsToCss({
  ...typographyOverrides.MuiTypography.h3,
  ...props
})}
`;
const LargeText = styled.p`
  ${props => propsToCss({
  ...typographyOverrides.MuiTypography.h2,
  ...props
})}
`;
const SmallText = styled.p`
  ${props => propsToCss({
  ...typographyOverrides.MuiTypography.body2,
  ...props
})}
`;
const SmallGrayText = styled(SmallText)`
  color: ${colors.grey};
`;
const SmallOrangeText = styled(SmallText)`
  color: orange;
  opacity: 0.8;
`;
const WarningText = styled(SmallText)``;
const LinkText = styled(LinkButton)`
  ${props => propsToCss({
  ...props
})};
`;
export { DefaultText, LargeText, LinkText, MediumText, SmallGrayText, SmallOrangeText, SmallText, WarningText };